<template>
    <span class="form-error"
          v-if="errorExists(errors, field)"
    >
        {{ getError(errors, field) }}
    </span>
</template>

<script>
export default {
    name: 'form-error',
    props: {
        errors: {
            type: Object,
            required: true
        },
        field: {
            type: String,
            required: true
        }
    },
    methods: {
        errorExists(errors, field) {
            return !!errors[field];
        },
        getError(errors, field) {
            if (errors[field]) {
                return errors[field][0];
            }
            return null;
        },
        getState(errors, field) {
            return errors[field] ? false : null
        },
    },
}
</script>
